export default {
  namespaced: true,
  state: {
    notifications: [],
    lastEventId: null, // latest event id for defects
  },
  mutations: {
    CLEAR_NOTIFICATION(state, notificationId) {
      const notification = state.notifications.find((n) => (n.event_id || n.id) === notificationId);
      if (notification) {
        notification.cleared = true;
        notification.seen = true;
      }
    },
    ADD_NOTIFICATION(state, notification) {
      // Use event_id if present, otherwise generate a robust unique ID
      const generateUniqueId = () =>
        `notif_${Math.random().toString(36).substr(2, 9)}_${Date.now()}`;
      const id = notification.event_id || generateUniqueId();
      // Check for existing notification with same id (event_id or generated)
      const exists = state.notifications.some((n) => n.id === id);
      if (exists) return;
      const newNotification = {
        id, // Use event_id from SSE if present, otherwise generated unique ID
        ...notification,
        dateTime: new Date().toISOString(),
        seen: false,
        cleared: false,
      };
      state.notifications.unshift(newNotification);
      // Keep only latest 50 notifications (remove extras from the end, in-place for reactivity)
      if (state.notifications.length > 50) {
        state.notifications.splice(50);
      }
    },
    CLEAR_ALL_NOTIFICATIONS(state) {
      state.notifications.forEach((notification) => {
        notification.cleared = true;
        notification.seen = true;
      });
    },
    MARK_NOTIFICATION_READ(state, notificationId) {
      const notification = state.notifications.find((n) => (n.event_id || n.id) === notificationId);
      if (notification) {
        notification.seen = true;
      }
    },
    MARK_ALL_NOTIFICATIONS_READ(state) {
      state.notifications.forEach((notification) => {
        notification.seen = true;
      });
    },
    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications;
    },
    SET_LAST_EVENT_ID(state, eventId) {
      state.lastEventId = eventId;
    },
  },
  actions: {
    clearNotification({ commit }, notificationId) {
      commit('CLEAR_NOTIFICATION', notificationId);
    },
    addNotification({ commit }, notification) {
      commit('ADD_NOTIFICATION', notification);
    },
    markNotificationRead({ commit }, notificationId) {
      commit('MARK_NOTIFICATION_READ', notificationId);
    },
    markAllNotificationsRead({ commit }) {
      commit('MARK_ALL_NOTIFICATIONS_READ');
    },
    setNotifications({ commit }, notifications) {
      commit('SET_NOTIFICATIONS', notifications);
      if (typeof window !== 'undefined' && window.vm && window.vm.$root) {
        notifications.forEach((n) => {
          if ((n.type === 'defect' || n.event_type === 'new_defect') && !n.cleared) {
            window.vm.$root.$emit('showSnackbar', {
              text: 'New defect detected in system',
              event_type: 'new_defect',
              defect: n.payload,
              timeout: 6000,
            });
          }
        });
      }
    },
    clearAllNotifications({ commit }) {
      commit('CLEAR_ALL_NOTIFICATIONS');
    },
    setLastEventId({ commit }, eventId) {
      commit('SET_LAST_EVENT_ID', eventId);
    },
  },
  getters: {
    unreadNotificationsCount: (state) =>
      state.notifications.filter((n) => !n.seen && !n.cleared).length,
    allNotifications: (state) => state.notifications.filter((n) => !n.cleared),
    lastEventId: (state) => state.lastEventId,
  },
};
